import { createApi } from "@reduxjs/toolkit/query/react";
import { fetchBaseQuery } from "@reduxjs/toolkit/query";
import { API_SERVER } from "../utils/urlBack_End";

export const qrVerificationApi = createApi({
  reducerPath: "qrVerificationApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${API_SERVER}/public`,
  }),
  endpoints: (builder) => ({
    verificarTokenQR: builder.query({
      query: (token) => `/verificar-qr?token=${token}`,
    }),
  }),
});

export const { useVerificarTokenQRQuery } = qrVerificationApi;
